module.exports = __webpack_public_path__ + "img/basic-case.d018f3b5.svg";